import { css } from '@emotion/react';

const listDocumentStyles = css`
    .list-document-container {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
    }

    .document-link {
        width: 100%;
    }
`;

export const listDocumentThemeStyles = css`
    .list-document-container {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
    }

    .document-link {
        width: 100%;
    }

    ul {
        padding: var(--listComponent-listPadding);
    }

    li {
        display: flex;
        break-inside: avoid;
        border-style: var(--listComponent-listItemBorderStyle);
        border-color: var(--listComponent-listItemBorderColor);
        border-width: var(--listComponent-listItemBorderWidth);
        font-family: var(--listComponent-listItemFontFamily);
        color: var(--listComponent-listItemTextColor);
        font-weight: var(--listComponent-listItemFontWeight);
        font-size: var(--listComponent-listItemFontSize);
        line-height: var(--listComponent-listItemLineHeight);
        padding: var(--listComponent-listItemPadding);
    }

    li:nth-child(even) {
        background-color: var(--listComponent-alternateListItemsBgColor);
    }

    i {
        color: var(--linkComponent-textColor);
    }

    a {
        font-size: var(--linkComponent-fontSize);
        font-weight: var(--linkComponent-fontWeight);
        font-family: var(--linkComponent-fontFamily);
        line-height: var(--linkComponent-lineHeight);
        color: var(--linkComponent-textColor);
        text-decoration: var(--linkComponent-textDecoration);

        &:hover {
            color: var(--linkComponent-hoverTextColor);
        }

        &:visited {
            color: var(--linkComponent-visitedTextColor);
        }

        &:active {
            color: var(--linkComponent-activeTextColor);
        }
    }
`;

export default listDocumentStyles;
